import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { config } from "./config";

export interface ImageGalleryImage {
  url: string;
  alternativeText?: string;
  caption?: string;
  formats?: {
    thumbnail?: { url: string };
    small?: { url: string };
    medium?: { url: string };
    large?: { url: string };
  };
}

interface ImageGalleryProps {
  images: ImageGalleryImage[];
  altFallback: string;
}



export const ImageGallery: React.FC<ImageGalleryProps> = ({ images, altFallback }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerOpen, setViewerOpen] = useState(false);

  if (!images.length) return null;

  const baseUrl = config.API_URL.replace("/api", "");

  let gridCols = "grid-cols-1";
  if (images.length === 2) gridCols = "grid-cols-2";
  else if (images.length === 3) gridCols = "grid-cols-3";
  else if (images.length >= 4) gridCols = "grid-cols-4";

  return (
    <div className="w-full mt-8">
      <div className={`grid ${gridCols} gap-4`}>
        {images.map((img, idx) => {
          // Only use thumbnail for grid, otherwise skip image
          const gridImgUrl = img.formats?.small?.url
            ? `${baseUrl}${img.formats.small.url}`
            : undefined;

          if (!gridImgUrl) return null;
          return (
            <button
              key={idx}
              className="focus:outline-none"
              onClick={() => { setCurrentImage(idx); setViewerOpen(true); }}
              aria-label={`View image ${idx + 1}`}
            >
              <div className="w-full aspect-square overflow-hidden rounded border border-gray-200 hover:opacity-80 transition">
                <img
                  src={gridImgUrl}
                  // alt={img.alternativeText || altFallback}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </button>
          );
        })}
      </div>
      {viewerOpen && (
        <Lightbox
          open={viewerOpen}
          close={() => setViewerOpen(false)}
          index={currentImage}
          slides={images.map((img) => ({
            src: `${baseUrl}${img.url}`,
            alt: img.alternativeText || altFallback,
            description: img.caption || undefined,
          }))}
          on={{
            view: ({ index }) => setCurrentImage(index),
          }}
          styles={{
            container: {
              background: "rgba(0,0,0,0.8)",
            },
          }}
        />
      )}
    </div>
  );
};
